import * as angular from 'angular';
import { Constants as constants } from '@constants/shared';
import { UsersRepo as usersRepo } from '@services/users.repo';
import { userList } from './userList';
import { userInfo } from './userDetails/userInfo';
import { addUserDetails } from './newUser/addUserDetails';
import { assignClients } from './newUser/assignClients';
import { userRolesTable } from './components/userRolesTable.component';
import { UserClientsTable } from './components/userClientsTable.component';

export const usersModule = 'users';

angular
  .module(usersModule, ['ui.router', 'dataGrid', 'pagination', 'angular-loading-bar', 'angularModalService'])
  .constant("config", constants.Default)
  .service('usersRepo', usersRepo)
  .component('userList', userList)
  .component('userRolesTable', userRolesTable)
  .component('userClientsTable', UserClientsTable)
  .component('userInfo', userInfo)
  .component('addUserDetails', addUserDetails)
  .component('assignClients', assignClients)




// WEBPACK FOOTER //
// ./src/app/users/users.index.ts